import { SORT_DIRECTION__ASC } from 'react-redux-app/lib/modules/table/constants';
import { SITE_ALIASES_GRID_NAME } from '../constants';

import { defaultFilter as defaultFilterBase } from '../../queryFilter/constants';

import { getGridFilterByName } from '../../queryFilter/utils/gridFilter';


export const getDefaultFilter = () => ({
  ...defaultFilterBase,
  sortField: 'hostName',
  sortDirection: SORT_DIRECTION__ASC,
});

export const getGridFilter = location => (
  getGridFilterByName(location, SITE_ALIASES_GRID_NAME, getDefaultFilter())
);
